import Vue from 'vue'
import Vuex from 'vuex'
import injector from 'vue-inject'
import itemModule from './itemModule/index'
import menuModule from '@/common/store/menuModule/index'
import menuPlugin from '@/common/store/menuModule/plugin'
import orderModule from './orderModule/index'
import mutations from './mutations'
import actions from './actions'
import authPlugin from './plugin/auth-plugin'
import orderSyncPlugin from './plugin/order-sync-plugin'
import localforagePlugin from './plugin/localforage-plugin'
import { validateReceiptCarrierId, validateTaxId, validatePhoneNumber } from '@/common/helpers/validators'

Vue.use(Vuex)

/**
 * 開始順序:
 * 從 firebase 檢查 accessToken，如果沒有的話就重新製造一個
 */

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging',
  modules: {
    itemModule,
    menuModule,
    orderModule
  },
  state: {
    accessToken: null,
    nickname: '',
    store: null,
    menuVariation: 'main',
    publicId: null,
    diningPreference: injector.get('diningPreferenceType').forHere,
    tableNumbers: [],
    tableNumber: null,
    phoneNumber: null,
    pickupTime: null,
    paymentMethod: null,
    paymentMethodDiscount: 0, // 付款方式折扣
    receiptCarrier: null,
    receiptCarrierId: '',
    taxId: '',
    invoiceTitle: '',
    menuUrl: '',
    businessHours: null
  },
  getters: {
    businessHours: state => state.businessHours,
    storeId: state => state.store ? state.store.id : null,
    payFirst: state => state.store ? state.store.payFirst : true,
    publicId: state => state.publicId,
    storeName: state => state.store ? state.store.name : null,
    storeBranch: state => state.store ? state.store.branch : null,
    useCashier: state => state.store ? state.store.useCashier : null,
    useReceipt: state => state.store ? state.store.useReceipt : null,
    serviceCharge: state => state.store ? state.store.serviceCharge : null,
    fullStoreName: (state, getters) => getters.storeBranch
      ? getters.storeName + ' - ' + getters.storeBranch
      : getters.storeName,
    currentMenu (state) {
      const version = state.menuModule.latestVersions[state.menuVariation]
      return state.menuModule.menus[state.menuVariation] && version
        ? state.menuModule.menus[state.menuVariation][version]
        : null
    },
    currentMenuTitle (state) {
      return state.menuModule.menus[state.menuVariation]
        ? state.menuModule.menus[state.menuVariation].title
        : null
    },
    isPayOnlyLinePay: state => {
      if (!state.store) return false
      return (state.store.shouldPreOrderPrePaid === true && state.diningPreference === injector.get('diningPreferenceType').preOrder)
    },
    isReceiptCarrierIdValid: state => validateReceiptCarrierId(state.receiptCarrier, state.receiptCarrierId),
    isTaxIdValid: state => validateTaxId(state.taxId),
    isPhoneNumberValid: state => validatePhoneNumber(state.phoneNumber),
    orderParams (state, getters) {
      const diningPreferenceType = injector.get('diningPreferenceType')
      const receiptCarrierType = injector.get('receiptCarrierType')

      const orderParams = Object.assign({
        agentId: state.agentId,
        diningPreference: state.diningPreference,
        receiptCarrier: state.receiptCarrier,
        paymentMethod: state.paymentMethod,
        originalPrice: getters['itemModule/totalPrice'],
        totalPrice: getters['itemModule/discountTotalPrice'], // totalPrice 修改成折扣後的價格
        menuVariation: state.menuVariation,
        menuVersion: state.menuModule.latestVersions[state.menuVariation]
      }, state.publicId ? { publicId: state.publicId } : {})

      if (state.diningPreference === diningPreferenceType.forHere) {
        orderParams['tableNumber'] = state.tableNumber
      } else if (state.diningPreference === diningPreferenceType.preOrder) {
        orderParams['pickupTime'] = state.pickupTime
        orderParams['phoneNumber'] = state.phoneNumber
      }

      orderParams['receiptCarrierId'] = state.receiptCarrier === receiptCarrierType.cdc || state.receiptCarrier === receiptCarrierType.barcode || state.receiptCarrier === receiptCarrierType.donate
        ? state.receiptCarrierId
        : null

      orderParams['taxId'] = state.taxId && state.taxId.length === 8 && !(getters.useCashier && getters.useReceipt && state.receiptCarrier !== receiptCarrierType.paper)
        ? state.taxId
        : null

      orderParams['invoiceTitle'] = !getters.useReceipt ? state.invoiceTitle : null

      return orderParams
    }
  },
  mutations,
  actions,
  plugins: [
    localforagePlugin, // 要放在前面，不然會把 auth 設好的 agentId 刪掉
    authPlugin,
    orderSyncPlugin,
    menuPlugin
  ]
})
